import originalDayjs, { extend } from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import isToday from 'dayjs/plugin/isToday'
import localeData from 'dayjs/plugin/localeData'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import weekday from 'dayjs/plugin/weekday'

extend(utc)
extend(timezone)
extend(weekday)
extend(localeData)
extend(duration)
extend(customParseFormat)
extend(relativeTime)
extend(isToday)

export const dayjs = originalDayjs
